var c;
var d;
module.exports.events = [
  "onShoot",
  "onMelee",
  "onDamage",
  "onEnter",
  "onDestroy",
  "onRespawn",
  "onTimer",
  "onProjectile",
  "onThrowingMelee",
  "onPunch",
  "onInteract",
  "onCollision",
  "onStorageEquals",
  "onStorageGreater",
  "onStorageLesser",
  "onAIDeath",
];
module.exports.actions = [
  {
    name: "Give Player Score",
    execute: function (f, g, h, j) {
      if (h) {
        f.players.score(h, j.triggerConstant || 1);
      }
    },
  },
  {
    name: "Kill Player",
    execute: function (f, g, h) {
      if (h) {
        if (!h.godMode) {
          f.players.kill(h);
        }
      }
    },
  },
  {
    name: "Respawn Player",
    execute: function (f, g, h) {
      if (h) {
        var j = f.getSpawnPoint(h.team, h);
        f.players.changePosition(h, j.x, j.y, j.z, true);
      }
    },
  },
  {
    name: "Change Player Health",
    execute: function (f, g, h, j) {
      if (h) {
        if (f.players.changeHealth(h, null, -(j.triggerConstant || 0), true)) {
          f.players.kill(h, null, {});
        }
      }
    },
  },
  {
    name: "Destroy Interface",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        d = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || d.sid != j.sid) &&
          (d.health || d.gate || (d.canDestroy && !d.destroyed)) &&
          d.interface != j.interface &&
          d.interface == j.interfaceT
        ) {
          d.active = false;
          if (d.gate) {
            g.broadcast("game" + f.sid, "gte", d.uid, d.active);
          } else {
            d.health = 0;
            d.destroyedBy = h;
            d.destroyed = true;
            f.map.manager.destObjs.push(d.uid);
            g.broadcast("game" + f.sid, "do", d.uid);
          }
          if (d.onDestroy || d.onDamage) {
            f.onTrigger(h, d, k);
          }
        }
      }
    },
  },
  {
    name: "Toggle Interface Gate",
    execute: function (f, g, h, j) {
      for (var k = 0; k < f.map.manager.interfaces.length; ++k) {
        d = f.map.manager.objects[f.map.manager.interfaces[k]];
        if (
          (j.isAI || d.sid != j.sid) &&
          d.gate &&
          d.interface != j.interface &&
          d.interface == j.interfaceT
        ) {
          d.active = !d.active;
          g.broadcast("game" + f.sid, "gte", d.uid, d.active);
        }
      }
    },
  },
  {
    name: "Change Interface Health",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        d = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || d.sid != j.sid) &&
          d.health &&
          d.interface != j.interface &&
          d.interface == j.interfaceT
        ) {
          d.health -= -(j.triggerConstant || 0);
          if (d.health <= 0) {
            d.active = false;
            d.health = 0;
            d.destroyedBy = h;
            d.destroyed = true;
            f.map.manager.destObjs.push(d.uid);
            g.broadcast("game" + f.sid, "do", d.uid);
            if (d && d.onDestroy) {
              f.onTrigger(h, d, k);
            }
          }
          if (d && d.onDamage && (j.triggerConstant || 0) < 0) {
            f.onTrigger(h, d, k);
          }
        }
      }
    },
  },
  {
    name: "Teleport To Interface",
    execute: function (f, g, h, j, k) {
      if (h) {
        for (
          var l = 0;
          l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
          ++l
        ) {
          d = f.map.manager.objects[f.map.manager.interfaces[l]];
          if (
            (j.isAI || d.sid != j.sid) &&
            (d.interface == null || d.interface != j.interface) &&
            d.interface == j.interfaceT
          ) {
            f.players.changePosition(h, d.x, d.y - d.height, d.z, true, true);
          }
        }
      }
    },
  },
  {
    name: "Change Interface Deposit Box Amount",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        d = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || d.sid != j.sid) &&
          d.interface != j.interface &&
          d.interface == j.interfaceT &&
          d.bank
        ) {
          d.deposited += j.triggerConstant || 0;
          g.broadcast("game" + f.sid, "bnk", d.uid, d.deposited);
        }
      }
    },
  },
  {
    name: "Kill Opposing Team",
    execute: function (f, g, h) {
      if (h) {
        for (var j = 0; j < f.players.list.length; ++j) {
          if (
            !!(c = f.players.list[j]).active &&
            c != h &&
            !c.godMode &&
            (!c.team || h.team != c.team)
          ) {
            f.players.kill(c, null, null, true);
          }
        }
      }
    },
  },
  {
    name: "Respawn Opposing Team",
    execute: function (f, g, h) {
      if (h) {
        for (var j = 0; j < f.players.list.length; ++j) {
          if (
            (c = f.players.list[j]).active &&
            c != h &&
            (!c.team || h.team != c.team)
          ) {
            var k = f.getSpawnPoint(c.team, c);
            f.players.changePosition(c, k.x, k.y, k.z, true);
          }
        }
      }
    },
  },
  {
    name: "Respawn Destructible Interface",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        d = f.map.manager.destObjs.indexOf(c.uid);
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.startHealth || (c.canDestroy && c.destroyed)) &&
          c.destroyed &&
          d != -1 &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          c.destroyed = false;
          f.map.manager.destObjs.splice(d, 1);
          c.active = true;
          c.respawnT = c.respawnR ? 0 : c.respawnTStart;
          if (c.health != null) {
            c.health = c.startHealth;
          }
          g.broadcast("game" + f.sid, "ro", c.uid);
          if (c && c.onRespawn && c.destroyedBy) {
            f.onTrigger(c.destroyedBy, c, k);
          }
          c.destroyedBy = null;
        }
      }
    },
  },
  {
    name: "Toggle Destructible Interface",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        d = f.map.manager.destObjs.indexOf(c.uid);
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.startHealth || c.canDestroy) &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          if (d == -1) {
            c.active = false;
            c.health = 0;
            c.destroyed = true;
            c.destroyedBy = h;
            f.map.manager.destObjs.push(c.uid);
            g.broadcast("game" + f.sid, "do", c.uid);
            if (c.onDestroy || c.onDamage) {
              f.onTrigger(h, c, k);
            }
          } else {
            f.map.manager.destObjs.splice(d, 1);
            c.active = true;
            c.destroyed = false;
            c.respawnT = c.respawnR ? 0 : c.respawnTStart;
            if (c.health != null) {
              c.health = c.startHealth;
            }
            g.broadcast("game" + f.sid, "ro", c.uid);
            if (c && c.onRespawn && c.destroyedBy) {
              f.onTrigger(c.destroyedBy, c, k);
            }
            c.destroyedBy = null;
          }
        }
      }
    },
  },
  {
    name: "Set Player Score",
    execute: function (f, g, h, j) {
      if (h) {
        f.players.score(h, j.triggerConstant || 0, false, true);
      }
    },
  },
  {
    name: "Broadcast Sound",
    custom: true,
    execute: function (f, g, h, j) {
      var k = j.triggerSound[3] && h;
      var l = k ? h : j;
      f.playSound(
        j.triggerSound[0],
        j.triggerSound[1],
        l.sid,
        l.x,
        k ? l.y + l.height : l.y,
        l.z,
        true,
        j.triggerSound[2],
        false,
        !k,
        !!j.triggerSound[4],
      );
    },
  },
  {
    name: "Clear Player Loadout",
    execute: function (f, g, h) {
      if (h && (h.loadout.length != 1 || h.loadout[0] != 12)) {
        h.updateLoadout(f, 0, true, 12);
        g.broadcast(
          "game" + f.sid,
          "inat",
          h.sid,
          [12],
          0,
          undefined,
          undefined,
          false,
        );
      }
    },
  },
  {
    name: "Broadcast Message",
    type: "Text",
    execute: function (f, g, h, j) {
      if (j.triggerConstantTxt && j.triggerConstantTxt.length) {
        g.broadcast("game" + f.sid, "ch", null, j.triggerConstantTxt, 2);
      }
    },
  },
  {
    name: "Send Message",
    type: "Text",
    execute: function (f, g, h, j) {
      if (h && j.triggerConstantTxt && j.triggerConstantTxt.length) {
        g.send(h.id, "ch", null, j.triggerConstantTxt, 2);
      }
    },
  },
  {
    name: "Swap Player Team",
    execute: function (f, g, h) {
      if (h) {
        var j = h.team == 2 ? 1 : 2;
        f.updateTeam(h, j);
      }
    },
  },
  {
    name: "Set Player Team",
    execute: function (f, g, h, j) {
      if (h) {
        var k = j.triggerConstant || 0;
        if (k > 2) {
          k = 2;
        }
        if (k < 1) {
          k = 1;
        }
        f.updateTeam(h, k);
      }
    },
  },
  {
    name: "Round Time",
    execute: function (f, g, h, j, k, l) {
      if (l.isNumber(f.gameTimer)) {
        var m = j.triggerConstant || 0;
        f.gameTimer += m;
        if (f.gameTimer <= 0) {
          f.gameTimer = "skip";
        }
      }
    },
  },
  {
    name: "Reset Interface",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || c.sid != j.sid) &&
          c.onTimer &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          if ((d = f.map.manager.destObjs.indexOf(c.uid)) != -1) {
            f.map.manager.destObjs.splice(d, 1);
            c.respawnT = c.respawnR ? 0 : c.respawnTStart;
            if (c.health != null) {
              c.health = c.startHealth;
            }
            g.broadcast("game" + f.sid, "ro", c.uid);
            if (c && c.onRespawn && c.destroyedBy) {
              f.onTrigger(c.destroyedBy, c, k);
            }
            c.destroyedBy = null;
          }
          c.triggerTimer = (c.triggerConstantEvent || 0) * 1000;
          c.health = c.startHealth;
          c.destroyed = false;
          c.active = true;
        }
      }
    },
  },
  {
    name: "End Round",
    execute: function (f) {
      if (f.gameTimer != "skip") {
        f.gameTimer = "skip";
      }
    },
  },
  {
    name: "Refill Player Knife",
    execute: function (f, g, h) {
      if (h) {
        h.refillKnife();
        g.send(h.id, "rfl");
      }
    },
  },
  {
    name: "Destroy Self",
    execute: function (f, g, h, j, k) {
      if ((j.health || j.gate || j.canDestroy) && j.active) {
        j.active = false;
        if (j.gate) {
          g.broadcast("game" + f.sid, "gte", j.uid, j.active);
        } else {
          j.health = 0;
          j.destroyed = true;
          j.destroyedBy = h;
          f.map.manager.destObjs.push(j.uid);
          g.broadcast("game" + f.sid, "do", j.uid);
        }
        if (!j.selfDestruct && (j.onDestroy || j.onDamage)) {
          f.onTrigger(h, j, k);
        }
      }
    },
  },
  {
    name: "Increase Interface Storage",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.onStorageEquals || c.onStorageGreater || c.onStorageLesser) &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          c.storage += j.triggerConstant || 0;
          if (c.storage == (c.triggerConstantEvent || 0) && c.onStorageEquals) {
            f.onTrigger(h, c, k);
          }
          if (c.storage > (c.triggerConstantEvent || 0) && c.onStorageGreater) {
            f.onTrigger(h, c, k);
          }
          if (c.storage < (c.triggerConstantEvent || 0) && c.onStorageLesser) {
            f.onTrigger(h, c, k);
          }
        }
      }
    },
  },
  {
    name: "Decrease Interface Storage",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.onStorageEquals || c.onStorageGreater || c.onStorageLesser) &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          c.storage -= j.triggerConstant || 0;
          if (c.storage == (c.triggerConstantEvent || 0) && c.onStorageEquals) {
            f.onTrigger(h, c, k);
          }
          if (c.storage > (c.triggerConstantEvent || 0) && c.onStorageGreater) {
            f.onTrigger(h, c, k);
          }
          if (c.storage < (c.triggerConstantEvent || 0) && c.onStorageLesser) {
            f.onTrigger(h, c, k);
          }
        }
      }
    },
  },
  {
    name: "Set Interface Storage",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.onStorageEquals || c.onStorageGreater || c.onStorageLesser) &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          c.storage = j.triggerConstant || 0;
          if (c.storage == (c.triggerConstantEvent || 0) && c.onStorageEquals) {
            f.onTrigger(h, c, k);
          }
          if (c.storage > (c.triggerConstantEvent || 0) && c.onStorageGreater) {
            f.onTrigger(h, c, k);
          }
          if (c.storage < (c.triggerConstantEvent || 0) && c.onStorageLesser) {
            f.onTrigger(h, c, k);
          }
        }
      }
    },
  },
  {
    name: "Reset Interface Storage",
    execute: function (f, g, h, j, k) {
      for (
        var l = 0;
        l < f.map.manager.interfaces.length && !(f.triggerChains[k] <= 0);
        ++l
      ) {
        c = f.map.manager.objects[f.map.manager.interfaces[l]];
        if (
          (j.isAI || c.sid != j.sid) &&
          (c.onStorageEquals || c.onStorageGreater) &&
          c.interface != j.interface &&
          c.interface == j.interfaceT
        ) {
          c.storage = 0;
          if (c.storage == (c.triggerConstantEvent || 0) && c.onStorageEquals) {
            f.onTrigger(h, c, k);
          }
          if (c.storage > (c.triggerConstantEvent || 0) && c.onStorageGreater) {
            f.onTrigger(h, c, k);
          }
          if (c.storage < (c.triggerConstantEvent || 0) && c.onStorageLesser) {
            f.onTrigger(h, c, k);
          }
        }
      }
    },
  },
  {
    name: "Broadcast Popup",
    type: "Text",
    execute: function (f, g, h, j) {
      if (j.triggerConstantTxt && j.triggerConstantTxt.length) {
        g.broadcast("game" + f.sid, "am", [j.triggerConstantTxt, null]);
      }
    },
  },
  {
    name: "Send Popup",
    type: "Text",
    execute: function (f, g, h, j) {
      if (h && j.triggerConstantTxt && j.triggerConstantTxt.length) {
        g.send(h.id, "am", [j.triggerConstantTxt, null]);
      }
    },
  },
  {
    name: "Jump Scare",
    execute: function (f, g, h) {
      if (h) {
        g.send(h.id, "scr", 0);
      }
    },
  },
];
